import React from 'react'
import ReportWrapper from '../ReportWrapper'
import ReportSectionHeading from '../ReportSectionHeading'
import { Stack, Text } from '@mantine/core'
import { useTheme } from '../../../components/ThemeProvider'
import dayjs from 'dayjs'
import TianyanchaRecordCard from '../TianyanchaRecordCard'

interface IllegalItem {
  putReason: string
  putDepartment: string
  putDate: number
  removeDepartment: string
  removeReason: string
}

interface Props {
  data: any
  title: string
  sectionIndex?: string
}

const formatDate = (timestamp?: number) => {
  if (!timestamp) return '—'
  return dayjs(timestamp).format('YYYY-MM-DD')
}

const normalizeItems = (items: IllegalItem[] = []) =>
  items.map((item) => ({
    reason: item.putReason || '—',
    department: item.putDepartment || '—',
    putDate: formatDate(item.putDate),
    removeDepartment: item.removeDepartment || '—',
    removeReason: item.removeReason || '—',
    status: item.removeDepartment && item.removeReason ? '已移出' : '未移出',
  }))

export default function TianyanchaIllegalinfo({ data, title, sectionIndex }: Props) {
  let jsonData: any
  try {
    jsonData = JSON.parse(data.tianyancha_illegalinfo ?? '{}')
  } catch (error) {
    jsonData = {}
  }

  const records = normalizeItems(jsonData.items)
  const theme = useTheme()

  return (
    <ReportWrapper>
      <ReportSectionHeading title={title} index={sectionIndex} />
      <div className="mt-2">
        <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
          经营异常与违法记录
        </Text>
        <Stack gap="sm" className="mt-3">
          {records.length === 0 ? (
            <Text c="dimmed" size="sm" ta="center">
              暂无经营异常或违法记录
            </Text>
          ) : (
            records.map((item, index) => (
              <TianyanchaRecordCard
                key={`${item.reason}-${index}`}
                number={index + 1}
                recordType="违法记录"
                fields={[
                  { label: '列入原因', value: item.reason },
                  { label: '列入机关', value: item.department },
                  { label: '列入日期', value: item.putDate },
                  { label: '状态', value: item.status, highlight: item.status === '未移出' },
                  { label: '移出机关', value: item.removeDepartment },
                  { label: '移出原因', value: item.removeReason },
                ]}
              />
            ))
          )}
        </Stack>
      </div>
    </ReportWrapper>
  )
}
